
import { CssBaseline, ThemeProvider } from "../components/legacy-ui/materialCompat";
import React from "react";
import theme from "./theme";

const MuiProvider = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default MuiProvider;
